// extracted by mini-css-extract-plugin
export default {"view":"style_view__AbQt2","form":"style_form__LATHF","trust":"style_trust__ypwa7"};